import { RootAppState } from 'store/configureStore'

export function projectValidityPeriodSelector(state: RootAppState) {
  return state.project?.activeProject?.validityPeriodDays
}
